function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Group 9");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "path-1",
  points: "0.119596542 0.104418142 52.8616715 0.104418142 52.8616715 62.9240361 0.119596542 62.9240361"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "path-3",
  points: "0 0.183949558 36.1181556 0.183949558 36.1181556 95.7367257 0 95.7367257"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Design",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Landing-Desktop",
  transform: "translate(-55.000000, -26.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-9",
  transform: "translate(55.000000, 26.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3",
  transform: "translate(30.138329, 0.136732)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M52.8616715,44.7171777 L45.5662824,62.2401334 L0.119596542,62.9240361 L0.557319885,60.7536821 C4.22654179,60.150806 5.62103746,57.6187263 6.14008646,53.075452 C6.65674352,48.5345892 11.3616715,9.70936792 11.5602017,5.53023075 C11.7611239,1.34868208 3.67878963,2.07454491 3.67878963,2.07454491 L3.92037464,0.104345796 L32.2838905,0.104345796 L32.0303458,2.17100509 C23.7805764,2.11312898 21.4484438,4.16290774 20.9509222,8.34686792 C20.4605764,12.4946555 15.3530865,51.5202728 15.1091095,53.8398989 C14.8811585,56.0071179 15.1851729,58.2466821 18.2504323,58.3807617 C18.5357896,58.3930604 34.0850144,58.3807617 34.0850144,58.3807617 C45.16683,58.3807617 51.1466571,44.7171777 51.1466571,44.7171777 L52.8616715,44.7171777 Z",
  id: "Fill-1",
  fill: "#919191",
  mask: "url(#mask-2)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group-6",
  transform: "translate(0.000000, 13.158856)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-4",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-3"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M36.1181556,0.183949558 L35.7689337,3.03675929 C29.8680403,3.03675929 29.430317,5.3855646 29.1815562,7.33888319 C27.8277233,17.9929097 25.1272334,44.4615823 23.8044957,57.5849894 C23.3356772,62.2391929 23.0414697,65.2149894 23.0414697,65.2149894 C23.0414697,65.2149894 21.7665706,84.1043035 17.5400288,89.7303434 C8.63487032,101.592534 0,92.2238389 0,92.2238389 L0.717579251,90.9360956 C11.6008646,98.1706088 12.6509222,83.5882416 13.0360231,79.3608743 C14.7031988,61.0213832 20.7715274,6.39357345 20.7715274,6.39357345 C20.7715274,6.39357345 21.3575504,2.78596283 15.9350432,3.10669292 L16.2938329,0.183949558 L36.1181556,0.183949558 Z",
  id: "Fill-4",
  fill: "#FFFFFF",
  mask: "url(#mask-4)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M61.802685,23.9244389 C59.6786504,39.9488858 34.7666908,35.3501469 34.7666908,35.3501469 L37.7972671,11.3605009 C37.7972671,11.3605009 64.0991778,6.5712531 61.802685,23.9244389 M60.3962297,53.373731 C58.8558262,71.3153239 30.8821951,66.094658 30.8821951,66.094658 L34.2237225,39.6426248 C41.2512153,39.0686867 61.8289963,36.6933549 60.3962297,53.373731 M71.6383046,22.3256115 C72.176489,7.49485929 53.5600914,7.29711593 44.8486793,7.29711593 C37.5915611,7.29711593 22.8764026,7.31158496 20.2117916,7.31399646 L19.9678147,9.30589912 C27.8372671,8.95381947 27.8635784,11.9802575 27.7463738,13.3427575 L36.1181317,13.3427575 L35.7689098,16.1955673 C29.8680164,16.1955673 29.4302931,18.5443726 29.1815323,20.4976912 C27.8276994,31.1517177 25.1272095,57.6203903 23.8044718,70.7437973 C50.8452499,70.0324035 68.5335784,71.3370274 71.279515,52.7708549 C73.3126562,39.0276912 58.9610712,37.3975142 58.9610712,37.3975142 C58.9610712,37.3975142 71.1001202,37.1563637 71.6383046,22.3256115",
  id: "Fill-7",
  fill: "#C8C8C8"
}))));

var SvgLogoFooter = function SvgLogoFooter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "84px",
    height: "110px",
    viewBox: "0 0 84 110",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoFooter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo_footer.d3328538.svg";
export { ForwardRef as ReactComponent };